import Client from '../HttpClient';

const baseUrl = '/gateway/eagle-mgt';

const list = (merchantId, payload) => {
	return Client.get(`${baseUrl}/priceTable/list/${merchantId}`, payload);
};

const create = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/categorys`, payload);
};

const find = (id, payload) => {
	return Client.get(`${baseUrl}/priceTable/detail/${id}`, payload);
};

const update = (payload) => {
	return Client.post(`${baseUrl}/priceTable/save`, payload);
};

const releaseConfig = (priceTableConfigVersionId, payload) => {
	return Client.post(
		`${baseUrl}/priceTable/release/${priceTableConfigVersionId}`,
		payload
	);
};

const remove = (id, payload) => {
	return Client.post(`${baseUrl}/priceTable/delete/${id}`, payload);
};

const discard = (priceTableConfigVersionId, payload) => {
	return Client.post(
		`${baseUrl}/priceTable/discard/${priceTableConfigVersionId}`,
		payload
	);
};

const historyList = (merchantId, id, payload) => {
	return Client.get(
		`${baseUrl}/priceTable/listVersion/${merchantId}/${id}`,
		payload
	);
};

const branchCategoryList = (payload) => {
	return Client.get(`${baseUrl}/productCategory/branches-list`, payload);
};

const branchProductList = (payload) => {
	return Client.get(`${baseUrl}/product/branches-list`, payload);
};

const categoryProductList = (payload) => {
	return Client.get(`${baseUrl}/product/productsByCategoryCodes`, payload);
};

export default {
	list,
	find,
	create,
	update,
	remove,
	discard,
	releaseConfig,
	historyList,
	branchCategoryList,
	branchProductList,
	categoryProductList,
};
